// @ts-nocheck
import React, { useEffect, useState } from 'react';
import AddPermission from '../slideout/AddPermission';
import RemovePermission from '../slideout/RemovePermission';
import KwPanel from '../../../common/KwPanel';
import SlidingPane from 'react-sliding-pane';
import icons from '../../../../constants/icons';
import Button from '../../../common/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../hooks';

function PermissionBadges({
  label,
  description,
  onAdd,
  onRemove,
  permissions,
}) {
  const [_permissions, setPermissions] = useState();
  const { t } = useTranslation();

  const currentUser = useAppSelector((state) => state.auth);

  useEffect(() => {
    setPermissions(permissions);
  }, [permissions]);

  const [addSlideoutOpen, setAddSlideoutOpen] = useState(false);
  const addPermission = (e) => {
    e.cancelBubble = true;
    setAddSlideoutOpen(true);
    return false;
  };

  const [removeSlideoutOpen, setRemoveSlideoutOpen] = useState(false);
  const [removeSlideoutItem, setRemoveSlideoutItem] = useState();
  const removePermission = (e, permissionKey) => {
    e.cancelBubble = true;
    setRemoveSlideoutItem(permissionKey);
    setRemoveSlideoutOpen(true);
    return false;
  };

  const PermissionTag = ({ permission }) => (
    <div className="tag" key={permission.permissionKey}>
      <span>{permission.permissionName}</span>
      <span
        className="ms-3 a"
        onClick={(e) => removePermission(e, permission.permissionKey)}
        title={t('Remove')}
      >
        <FontAwesomeIcon icon={icons.DELETE_TAG} />
      </span>
    </div>
  );

  return (
    <>
      <KwPanel className="mb-4">
        <header className="mb-2">
          <h2 className="no-margin">{label || 'Permissions'}</h2>
          <div className="float-right">
            <Button
              className="btn btn-default"
              onClick={addPermission}
              text={t('Edit')}
            />
          </div>
        </header>
        {description && <div>{description}</div>}
        <div className="mt-3 tags">
          {_permissions && _permissions.length > 0 ? (
            _permissions.map((x, i) => <PermissionTag key={i} permission={x} />)
          ) : (
            <></>
          )}
        </div>
      </KwPanel>

      <SlidingPane
        isOpen={addSlideoutOpen}
        hideHeader={true}
        from="right"
        className="large-side-panel"
        onRequestClose={() => setAddSlideoutOpen(false)}
      >
        <AddPermission
          permissionKeys={
            _permissions ? _permissions.map((x) => x.permissionKey) : []
          }
          currentUser={currentUser}
          cancel={() => setAddSlideoutOpen(false)}
          done={(d) => {
            if (d.added) {
              onAdd(d.added);
            }
            if (d.removed) {
              onRemove(d.removed);
            }
            setAddSlideoutOpen(false);
          }}
        />
      </SlidingPane>

      <SlidingPane
        isOpen={removeSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setRemoveSlideoutOpen(false)}
      >
        <>
          {removeSlideoutItem && (
            <RemovePermission
              permissionKeys={[removeSlideoutItem]}
              done={(d) => {
                setRemoveSlideoutOpen(false);
                onRemove(d);
              }}
              cancel={() => setRemoveSlideoutOpen(false)}
            />
          )}
        </>
      </SlidingPane>
    </>
  );
}

export default PermissionBadges;
